// @ts-strict-ignore
import { inject, injectable, injectWithTransform } from "tsyringe";
import {
  DataWarehouseEventType,
  DataWarehouseService,
} from "../DataWarehouseService";
import { Logger, LoggerTransformer } from "@identity/utils";
import { WINDOW } from "@identity/symbols";

@injectable()
export class HemTrackingService {
  constructor(
    @inject(DataWarehouseService) private dataWarehouse: DataWarehouseService,
    @inject(WINDOW) private window: Window,
    @injectWithTransform(Logger, LoggerTransformer, "HemTracking")
    private logger: Logger,
  ) {}

  activateTracking(): void {
    if (!this.isEnabled()) {
      this.logger.info("Hem Tracking is disabled");
      return;
    }

    const hems = this.extractHEMs();
    Object.keys(hems).forEach((key) => {
      if (hems[key]) {
        this.dataWarehouse.track(DataWarehouseEventType.identity, {
          partner_name: "MediaWiki-" + key,
          partner_identity_id: hems[key],
        });
      }
    });
  }

  private isEnabled(): boolean {
    return (
      this.window.ads?.context?.opts?.userEmailHashes &&
      this.window.ads.context.opts.userEmailHashes.length > 0
    );
  }

  private extractHEMs() {
    const [md5, sha1, sha256] = this.window.ads.context.opts.userEmailHashes;
    return {
      md5,
      sha1,
      sha256,
    };
  }
}
